/**
 * Mapeo centralizado de secciones a códigos de permisos
 * Única fuente de verdad para el mapeo de permisos
 * Basado en el array PERMISSIONS completo
 */

export const SECTION_PERMISSION_MAP: {
  [key: string]: {
    create?: string;
    read: string;
    update?: string;
    delete?: string;
  };
} = {
  Usuarios: { create: '0101', read: '0102', update: '0103', delete: '0104' },
  Empresa: { read: '0202', update: '0203' }, // No tiene create ni delete
  Reclamos: { create: '0301', read: '0302', update: '0303', delete: '0304' },
  Diagnosticos: {
    create: '0401',
    read: '0402',
    update: '0403',
    delete: '0404',
  },
  Cotizacion: { create: '0501', read: '0502', update: '0503', delete: '0504' },
  Citas: { create: '0601', read: '0602', update: '0603', delete: '0604' },
  Recepciones: { create: '0701', read: '0702', update: '0703', delete: '0704' },
  'Ordenes de Trabajos': {
    create: '0801',
    read: '0802',
    update: '0803',
    delete: '0804',
  },
  Clientes: { create: '0901', read: '0902', update: '0903', delete: '0904' },
  Vehiculos: { create: '1001', read: '1002', update: '1003', delete: '1004' },
  'Maestro de Articulos': {
    create: '1101',
    read: '1102',
    update: '1103',
    delete: '1104',
  },
  'Orden de Compra': {
    create: '1201',
    read: '1202',
    update: '1203',
    delete: '1204',
  },
  Conduce: { create: '1301', read: '1302', update: '1303', delete: '1304' },
  Piezas: { create: '1401', read: '1402', update: '1403', delete: '1404' },
  Materiales: { create: '1501', read: '1502', update: '1503', delete: '1504' },
  Devoluciones: {
    create: '1601',
    read: '1602',
    update: '1603',
    delete: '1604',
  },
  Reportes: { read: '1702' }, // Solo tiene read
  Aseguradoras: {
    create: '1801',
    read: '1802',
    update: '1803',
    delete: '1804',
  },
  Proveedores: { create: '1901', read: '1902', update: '1903', delete: '1904' },
  Casos: { create: '2001', read: '2002', update: '2003', delete: '2004' },
  Roles: { create: '2101', read: '2102', update: '2103', delete: '2104' },
};
